import { render, staticRenderFns } from "./AgentIntro.vue?vue&type=template&id=08a264f5&scoped=true"
import script from "./AgentIntro.vue?vue&type=script&lang=ts"
export * from "./AgentIntro.vue?vue&type=script&lang=ts"
import style0 from "./AgentIntro.vue?vue&type=style&index=0&id=08a264f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a264f5",
  null
  
)

export default component.exports